import stripeicon from "assets/images/stripe-payment.svg";
import momomtn from "assets/icons/momo-payment.svg";
import paystack from "assets/icons/Paystack_Logo 1.svg";
import flutterwave from "assets/icons/Flutterwave_Logo 1.svg";
import remita_logo from "assets/icons/remita_logo.png";
import cowvaWallet from "assets/images/cowva-wallet.svg";

export const walletOptions = [
  {
    id: "stripe",
    name: "Stripe",
    image: stripeicon,
    lgscreenw: "320px",
    colSpan: "col-span-2",
    lgscreenh: "134px",
    customWidth: "387px",
    disabled: true,
  },
  // {
  //   id: "momo",
  //   name: "MoMo from MTN",
  //   image: momomtn,
  //   colSpan: "col-span-3",
  //   lgscreenw: "307px",
  //   lgscreenh: "146px",
  //   customWidth: "347px",
  // },
  {
    id: "cowva-wallet",
    name: "Cowva Wallet",
    image: cowvaWallet,
    colSpan: "col-span-2",
    lgscreenw: "261px",
    lgscreenh: "63px",
    customWidth: "277px",
    disabled: false,
  },
  {
    id: "paystack",
    name: "Paystack",
    image: paystack,
    colSpan: "col-span-3",
    lgscreenw: "416px",
    lgscreenh: "73px",
    customWidth: "456px",
    disabled: true,
  },
  {
    id: "remita",
    name: "Remita",
    image: remita_logo,
    colSpan: "col-span-2",
    lgscreenw: "261px",
    lgscreenh: "63px",
    customWidth: "277px",
    disabled: true,
  },
];

export interface RowData {
  accountId: number | string; // Added accountId for better tracking
  bankIcon: string;
  bankName: string;
  accountName: string;
  accountNumber: string;
}

export const Banks: RowData[] = [
  {
    accountId: 1, // Unique ID for tracking
    bankIcon: "https://example.com/icons/gt-bank.svg", // Icon URL from response
    bankName: "GT Bank",
    accountName: "Ibu Wisdom",
    accountNumber: "0141012282",
  },
  {
    accountId: 2, // Unique ID for tracking
    bankIcon: "https://example.com/icons/zenith-bank.svg", // Another example icon
    bankName: "Zenith Bank",
    accountName: "Ibu Wisdom",
    accountNumber: "0141012283",
  },
  {
    accountId: 3, // Unique ID for tracking
    bankIcon: "https://example.com/icons/uba-bank.svg", // Another example icon
    bankName: "UBA Bank",
    accountName: "Ibu Wisdom",
    accountNumber: "0141012284",
  },
];
